import { useStateMachine } from "#/components/context/stateMachine/StateMachineContext"
import { IlloUnderwaterPlants } from "#/components/views/atoms/Illustrations"
import { Link, Typography, Box, Button } from "@carrotfertility/carotene-core"
import React from "react"
import { Link as ReactRouterLink } from "react-router-dom"
import { createErrorBoundary } from "#/utils/createErrorBoundary"
import { useEnrollmentFlowModal } from "../EnrollmentModal"
import useSubmitWithErrorCatch from "../hooks/useSubmitWithErrorCatch"
import { BenefitEnrollmentFlowModalBackButton } from "../shared"
import { Steps } from "../workflow/steps"
import { getHelpPath } from "../../talk-to-carrot/util/talkToCarrotMolecules"
import { Paths } from "../../../utils/Paths"
import { FormattedMessage } from "react-intl"

const ViewName = Steps.UNKNOWN_ERROR

export const EnrollmentErrorBoundary = createErrorBoundary(UnhandledEnrollmentErrorView)

// @ts-expect-error TS(7031) FIXME: Binding element 'unsetError' implicitly has an 'an... Remove this comment to see the full error message
function UnhandledEnrollmentErrorView({ unsetError }): JSX.Element {
  const { onExit } = useEnrollmentFlowModal()
  const { onSubmit } = useSubmitWithErrorCatch(() => {
    unsetError()
  })
  useStateMachine(ViewName, null)
  const helpPath = `${getHelpPath({ baseUrl: Paths.TALK_TO_CARROT })}/?enrollmentFlowError=enrollmentFlowUnknownError`

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div onClick={onSubmit}>
        <BenefitEnrollmentFlowModalBackButton />
      </div>
      <Box height={(theme) => theme.tokens.spacing.lg} />
      <Box display="flex" justifyContent="center">
        <IlloUnderwaterPlants />
      </Box>
      <Box height={(theme) => theme.tokens.spacing.xl} />
      <div className="flex flex-row justify-center">
        <Typography id="step-heading" variant="h2" color={(theme) => theme.palette.text.primary}>
          <FormattedMessage defaultMessage="An unknown error occurred." />
        </Typography>
      </div>
      <Typography
        color={(theme) => theme.palette.text.secondary}
        paddingTop={(theme) => theme.tokens.spacing.md}
        paddingBottom={(theme) => theme.tokens.spacing.xxxl}
      >
        <FormattedMessage
          defaultMessage="We're not sure what happened. Please go back and try again. If that doesn't 
        work, contact the <link>Care Team for more support.</link>"
          values={{
            link: (linkContent) => (
              <Link color={"inherit"} component={ReactRouterLink} to={helpPath}>
                {linkContent}
              </Link>
            )
          }}
        />
      </Typography>
      <div className="flex flex-row justify-center">
        <Button onClick={onExit}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </div>
    </>
  )
}
